import { GlobalSettingsKeys } from '../../api/models/GlobalSettingsKeys';
import { IBookmarkElementV1 } from '../../api/models/AndromeTV.types';
import { Backend } from '../../api/Backend';

export class BookmarkUtility {
  static isPartial(backend: Backend, bookmark: IBookmarkElementV1) {
    if (bookmark.size > 0) {
      return (
        bookmark.position <
        bookmark.size * (backend.globalSettings.numberValue(GlobalSettingsKeys.bookmarksMaximumPercent) ?? 1)
      );
    }
    return false;
  }

  static isFullyWatched(backend: Backend, bookmark: IBookmarkElementV1) {
    if (bookmark.size > 0) {
      return (
        bookmark.position >=
        bookmark.size * (backend.globalSettings.numberValue(GlobalSettingsKeys.bookmarksMaximumPercent) ?? 1)
      );
    }
    return false;
  }

  static getLatestBookmark(bookmarks: IBookmarkElementV1[]): IBookmarkElementV1 | undefined {
    let lastBookmark: IBookmarkElementV1 | undefined = undefined;
    bookmarks.forEach(bookmark => {
      if (!lastBookmark || parseInt(lastBookmark.lastUpdate, 10) < parseInt(bookmark.lastUpdate, 10)) {
        lastBookmark = bookmark;
      }
    });
    return lastBookmark;
  }
}
